import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface DeleteTestimonialDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  testimonialName: string;
  testimonialCompany: string;
  onConfirm: () => void;
}

export function DeleteTestimonialDialog({
  open,
  onOpenChange,
  testimonialName,
  testimonialCompany,
  onConfirm,
}: DeleteTestimonialDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Testimonial</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete the testimonial from{" "}
            <span className="font-semibold">
              {testimonialName}
            </span>{" "}
            at{" "}
            <span className="font-semibold">
              {testimonialCompany}
            </span>
            ?
            <br />
            <br />
            This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            Delete Permanently
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
